(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- day / night ---------- */
  function syncModeContent(mode) {
    document.querySelectorAll('[data-kz-alt-day][data-kz-alt-night]').forEach(function (el) {
      var label = el.getAttribute(mode === 'night' ? 'data-kz-alt-night' : 'data-kz-alt-day');
      el.setAttribute(el.tagName.toLowerCase() === 'img' ? 'alt' : 'aria-label', label);
    });
  }
  function setMode(mode) {
    root.setAttribute('data-kz-mode', mode);
    syncModeContent(mode);
    try { localStorage.setItem('kz-mode', mode); } catch (e) {}
    document.querySelectorAll('.kz-mode-toggle').forEach(function (b) {
      b.setAttribute('aria-pressed', mode === 'night' ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.kz-mode-toggle');
    if (!t) return;
    setMode(root.getAttribute('data-kz-mode') === 'night' ? 'day' : 'night');
  });
  document.querySelectorAll('.kz-mode-toggle').forEach(function (b) {
    b.setAttribute('aria-pressed', root.getAttribute('data-kz-mode') === 'night' ? 'true' : 'false');
  });

  syncModeContent(root.getAttribute('data-kz-mode') || 'day');
  document.addEventListener('shopify:section:load', function () { syncModeContent(root.getAttribute('data-kz-mode') || 'day'); });

  /* ---------- header shadow on scroll ---------- */
  var scrolled = false;
  function onScroll() {
    var s = window.scrollY > 10;
    if (s !== scrolled) { scrolled = s; root.classList.toggle('kz-scrolled', s); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- toast ---------- */
  var toast, tt;
  window.kzToast = function (msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'kz-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  };

  /* ---------- fly-to-cart ---------- */
  function bump() {
    var b = document.getElementById('cart-icon-bubble');
    if (!b) return;
    b.classList.remove('kz-bump'); void b.offsetWidth; b.classList.add('kz-bump');
  }
  function fly(fromEl, done) {
    var target = document.getElementById('cart-icon-bubble');
    if (reduce || !fromEl || !target || !fromEl.animate) { bump(); done(); return; }
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, x1 = b.left + b.width / 2, y1 = b.top + b.height / 2;
    var d = document.createElement('span'); d.className = 'kz-fly'; document.body.appendChild(d);
    var anim = d.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(.6)' },
      { transform: 'translate(' + ((x0 + x1) / 2) + 'px,' + (Math.min(y0, y1) - 90) + 'px) scale(1.25)', offset: .45 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.5)', opacity: .7 }
    ], { duration: 650, easing: 'cubic-bezier(.5,0,.3,1)' });
    anim.onfinish = function () { d.remove(); bump(); done(); };
  }

  /* ---------- add to cart (single product or a whole bundle) ---------- */
  function refreshBubble() {
    return fetch(base + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (data) {
      var html = data && data['cart-icon-bubble'];
      var el = document.getElementById('cart-icon-bubble');
      if (!html || !el) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('.shopify-section');
      el.innerHTML = inner ? inner.innerHTML : html;
    }).catch(function () {});
  }

  /* items: [{id, quantity}]. Opens Dawn's cart drawer when the theme uses it; otherwise shows a toast. */
  window.kzAddToCart = function (items, opts) {
    opts = opts || {};
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.renderContents === 'function') {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { window.kzToast(res.j.description || res.j.message || opts.error || 'Error'); return false; }
        return new Promise(function (resolve) {
          fly(opts.from, function () {
            if (body.sections && res.j.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents({ id: items[0].id, sections: res.j.sections });
            } else {
              if (opts.added) window.kzToast(opts.added);
              refreshBubble();
            }
            resolve(true);
          });
        });
      })
      .catch(function () { window.kzToast(opts.error || 'Error'); return false; });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-kz-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    window.kzAddToCart([{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }], {
      from: btn, added: form.dataset.added + ': ' + form.dataset.title, error: form.dataset.error
    }).then(function (ok) {
      if (!btn) return;
      btn.disabled = false;
      if (ok) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1400); }
    });
  });

  /* ---------- hero parallax (mouse only) ---------- */
  if (!reduce && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('[data-kz-parallax]').forEach(function (wrap) {
      wrap.addEventListener('pointermove', function (e) {
        var r = wrap.getBoundingClientRect(), mx = (e.clientX - r.left) / r.width - .5, my = (e.clientY - r.top) / r.height - .5;
        wrap.style.setProperty('--kz-mx', mx.toFixed(3)); wrap.style.setProperty('--kz-my', my.toFixed(3));
      });
      wrap.addEventListener('pointerleave', function () { wrap.style.removeProperty('--kz-mx'); wrap.style.removeProperty('--kz-my'); });
    });
  }
})();
